/**
 * @generated SignedSource<<32ed93a2e5a13176a3c096d135f48492>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerApplicationFormSelector_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationContactDetails_viewer" | "SellerApplicationFormInventorySample_viewer">;
  readonly " $fragmentType": "SellerApplicationFormSelector_viewer";
};
export type SellerApplicationFormSelector_viewer$key = {
  readonly " $data"?: SellerApplicationFormSelector_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationFormSelector_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerApplicationFormSelector_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerApplicationContactDetails_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerApplicationFormInventorySample_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "51807a1466169d678c0738e497499de6";

export default node;
